/**
 * Converts a Base64-encoded string to an ArrayBuffer.
 * @param {string} base64String - The Base64-encoded string to convert.
 * @returns {ArrayBuffer} The ArrayBuffer containing the decoded data.
 */
export function convertBase64ToArrayBuffer(base64String) {
  if (typeof base64String !== 'string') {
    throw new TypeError('base64String must be a string');
  }

  const decodedData = atob(base64String);
  const byteArray = new Uint8Array(decodedData.length);

  for (let i = 0; i < decodedData.length; i += 1) {
    byteArray[i] = decodedData.charCodeAt(i);
  }

  return byteArray.buffer;
}
